import { useTranslation } from "react-i18next";
import { useSkipDates } from "./useSkipDates";
import { Combobox } from "@ttc3k/trekker";

export const SkipDates = () => {
  const { t } = useTranslation("events", {
    keyPrefix: "APP.MODAL.EVENT_SCHEDULE.RECURRING_EVENT.SKIP_DATES",
  });
  const {
    skipDates,
    filteredSkippableDatesCollection,
    handleComboboxValueChange,
    handleComboboxInputValueChange,
    handleComboboxOpenChange,
  } = useSkipDates();

  return (
    <Combobox.Root
      value={skipDates}
      collection={filteredSkippableDatesCollection}
      multiple
      label={t("TITLE")}
      hint={t("DESCRIPTION")}
      tagVisualVariant={"accent.blue"}
      onValueChange={d => handleComboboxValueChange(d.value)}
      onInputValueChange={d => handleComboboxInputValueChange(d.inputValue)}
      onOpenChange={d => handleComboboxOpenChange(d.open)}
    >
      {filteredSkippableDatesCollection.items.map(date => (
        <Combobox.Item key={date.value} item={date} {...date} />
      ))}
    </Combobox.Root>
  );
};
